module.exports = __webpack_public_path__ + "img/tl.8912ab28.png";